import { apiV2 } from 'src/services/storage/project/http'
import * as types from './types'

export * from './types'

export const getSchemeRelations = ({
  schemeName,
}: types.IGetSchemeRelationsParams) =>
  apiV2.get<types.ISchemeRelations>(`/scheme/${schemeName}/relations`)
